import script from "./QualificationsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./QualificationsModal.vue?vue&type=script&setup=true&lang=js"

import "./QualificationsModal.vue?vue&type=style&index=0&id=4d6eeb83&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d6eeb83"]])

export default __exports__